import cn from 'classnames';
import { Link } from 'react-router-dom';
import ActivePlayersCount from '@components/active-players-count';
import styles from './game-card.module.scss';

interface IProps {
  activePlayers: number;
  picture: string;
  title: string;
  to: string;
  className?: string;
}

const GameCard = ({
  activePlayers,
  picture,
  title,
  to,
  className = '',
}: IProps): JSX.Element => {
  return (
    <Link className={cn(styles.card, className)} {...{ to }}>
      <figure className={styles.card__picture}>
        <img src={picture} alt={title} />
      </figure>
      <div className={styles.info}>
        <h3>{title}</h3>
        <ActivePlayersCount
          {...{ activePlayers }}
          className={styles[`info__players-count`]}
        />
      </div>
    </Link>
  );
};

export default GameCard;
